<template>
    <div id="collections-introduction">
        <AnimatedHeader :animate="animateHeader" :labels="collectionsNames" :show-overlay="true">
            <AnimatedHeaderContent :art="art" :title="artAlternativeText" />
        </AnimatedHeader>

        <div class="medium-content">
            <h2 class="collections-header-art text-center">
                {{ title }}
            </h2>

            <div style="columns: 2; column-gap: 2rem">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    import AnimatedHeader from '../../common/AnimatedHeader';
    import AnimatedHeaderContent from '../../common/AnimatedHeaderContent';

    export default {
        name: 'PartnersPageIntro',
        props: ['title', 'art', 'artAlternativeText', 'collectionsNames', 'animateHeader'],
        components: { AnimatedHeaderContent, AnimatedHeader },
    };
</script>
